import cx from 'classnames';
import PropTypes from 'prop-types';

import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';

import { useStyles } from './useStyles';

export const BlockedSectionContent = ({ className, title, description }) => {
  const styles = useStyles();

  return (
    <div className={cx(styles.root, className)}>
      <CustomTypography
        className={styles.title}
        variant={TYPOGRAPHY_VARIANT.medium14}
      >
        {title}
      </CustomTypography>

      {description && (
        <CustomTypography
          className={styles.message}
          variant={TYPOGRAPHY_VARIANT.paragraph14}
        >
          {description}
        </CustomTypography>
      )}
    </div>
  );
};

BlockedSectionContent.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
};

BlockedSectionContent.defaultProps = {
  className: null,
  description: null,
};
